import cc from "classcat"
import { motion, Variants } from "framer-motion"

const cardVariants: Variants = {
  offscreen: {
    y: 150,
    opacity: 0,
  },
  onscreen: {
    y: 0,
    opacity: 1,
    transition: {
      type: "spring",
      bounce: 0.6,
      duration: 1.5,
    },
  },
}

const MovingImage = ({ children }) => {
  return (
    <motion.div
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: true, amount: 1, margin: "100px" }}
    >
      <motion.div variants={cardVariants}>{children}</motion.div>
    </motion.div>
  )
}

const Quote = ({ Image, text, reversed = false }) => {
  return (
    <div
      className={cc([
        "sm:rounded-6xl flex flex-col rounded-lg bg-zinc-200 lg:flex-row ",
        { "lg:flex-row-reverse": !reversed },
      ])}
    >
      <div
        className={cc([
          "grow-1 relative mx-auto -mt-8 w-40 shrink-0 transform transition-transform duration-300 hover:-translate-y-2 md:w-64 md:[shape-outside:circle(60%)] lg:w-64",
          reversed ? "lg:ml-8" : "lg:mr-8",
        ])}
      >
        <MovingImage>
          <Image />
        </MovingImage>
      </div>
      <div className="px-4 py-4 sm:px-10 sm:py-8 md:py-12 lg:px-20 lg:py-16">
        <p className="mt-8 p-0 font-display text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl">
          {text}
        </p>
      </div>
    </div>
  )
}

export default Quote
